// extracted by mini-css-extract-plugin
module.exports = {"avatarLink":"MessengerMessageAvatar_avatarLink__28Ybk","avatarLink_right":"MessengerMessageAvatar_avatarLink_right__18EdK","avatarUser":"MessengerMessageAvatar_avatarUser__3-4bU"};